// extracted by mini-css-extract-plugin
module.exports = {"container":"TextComponent_container__Sm8kY"};